export const MESSAGES = {
  imageIsRequired: "Images are required.",
  notMoreFiveImage: "You can upload 5 images.",
  somethingWentWrong: "Something Went Wrong",
  imageSize: 'Images can be up to 20 MB in size, and videos can be up to 1 GB.',
  workHasBeenSuccessfullyCreated: "Work has been successfully created",
  blogHasBeenSuccessfullyCreated: "Blog has been successfully created",
  blogHasBeenSuccessfullyUpdated: "Blog has been successfully updated",
  recipeHasBeenSuccessfullyCreated: "Recipe has been successfully created",
  recipeHasBeenSuccessfullyUpdated: "Recipe has been successfully updated",
  productHasBeenSuccessfullyCreated: "Product has been successfully created",
  productHasBeenSuccessfullyUpdated: "Product has been successfully updated",
  marketHasBeenSuccessfullyCreated: "Market has been successfully created",
  marketHasBeenSuccessfullyUpdated: "Market has been successfully updated",
  ingredientsHasBeenSuccessfullyUpdated: "Ingredient has been successfully created",
  ingredientsHasBeenSuccessfullyCreated: "Ingredient has been successfully updated",
  mapMarkHasBeenSuccessfullyCreated: "Maps Mark has been successfully created",
  mapMarkHasBeenSuccessfullyUpdated: "Maps Mark has been successfully updated",
  teamHasBeenSuccessfullyUpdated: "Team has been successfully created",
  teamHasBeenSuccessfullyCreated: "Team has been successfully updated",
  faqHasBeenSuccessfullyUpdated: "Faq has been successfully created",
  faqHasBeenSuccessfullyCreated: "Faq has been successfully updated",
  mapConfigHasBeenSuccessfullyUpdated: "Configs has been successfully created",
  mapConfigHasBeenSuccessfullyCreated: "Configs has been successfully updated",
}
